export const expectedDepartments = [
  { _id: '6440e7c18422a203756af274', department_name: 'Mobilezone DE - Customer Care' },
  { _id: '65f1b308e4e23cf23d2c2cef', department_name: 'Mobilezone CH - Customer Care' },
  { _id: '64648a4a27e0949da904059e', department_name: 'Helpdesk' }
]
